export default {
    variants: {}
}
